import { GitFork, Sparkles, TerminalSquare } from 'lucide-react';

const icons = {
  GitFork,
  Sparkles,
  TerminalSquare,
};

export default function QuickStart({ content }) {
  return (
    <section className="section section-start" id="start">
      <div className="section-inner split-section">
        <div className="section-header">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2>{content.title}</h2>
          <p>{content.intro}</p>
        </div>

        <div className="principle-grid">
          {content.cards.map((card) => {
            const Icon = icons[card.icon];
            return (
              <article className="principle-card" key={card.title}>
                <span className="card-icon">
                  <Icon size={21} />
                </span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
